<p>view-nursing-assessment-by-id works!</p>
